import Page from 'src/pages/logout/success';

export default Page;
